import * as actionTypes from '../../actionTypes';
import createReducer from '../../../../common/utils/createReducer';
import * as adminTypes from '../../../../common/actionTypes/adminTypes';
import * as translationTypes from '../../../../common/actionTypes/translationsActionTypes';
import { setItemInPersistentStore } from '../../utils/Persist';
import get from 'lodash/get';

const INITIAL_STATE = {
  isLoading: false,
  userDetails: null,
  isUserPresent: false,
  loginPageWidget: [],
  isLoginPageWidgetLoading: true
}

const reducer = {
  [adminTypes.SIGNOUT_USER_ON_AUTHENTICATION_FAIL]: (state, action) => {
    return INITIAL_STATE;
  },
  [actionTypes.POST_OAUTH_TOKEN]: (state, action) => {
    const { isLoading } = action.payload;
    return {
      ...state,
      isLoading
    };
  },
  [actionTypes.POST_OAUTH_TOKEN_SUCCESS]: (state, action) => {
    const { userDetails, isLoading } = action.payload;
    setItemInPersistentStore('user_details', userDetails);
    setItemInPersistentStore('isLoggedIn', true);
    return {
      ...state,
      userDetails,
      isLoading,
    };
  },
  [actionTypes.POST_SIGN_IN_SUCCESS]: (state, action) => {
    const { userDetails } = action.payload;
    return {
      ...state,
      userDetails,
    };
  },
  [actionTypes.POST_SIGN_UP_SUCCESS]: (state, action) => {
    const { userDetails } = action.payload;
    return {
      ...state,
      userDetails,
    };
  },
  [actionTypes.GENERATE_OTP_SUCCESS]: (state, action) => {
    const { isUserPresent } = action.payload;
    return {
      ...state,
      isUserPresent
    };
  },
  [actionTypes.START_FETCHING_LOGIN_PAGE_WIDGET]: (state, action) => {
    return {
      ...state,
      isLoginPageWidgetLoading: true
    };
  },
  [actionTypes.SAVE_LOGIN_PAGE_WIDGET]: (state, action) => {
    const widgetList = get(action.payload, 'data.widget_list', []);
    return {
      ...state,
      loginPageWidget: widgetList,
      isLoginPageWidgetLoading: false
    };
  },
  [actionTypes.ERROR_FETCHING_LOGIN_PAGE_WIDGET]: (state, action) => {
    return {
      ...state,
      isLoginPageWidgetLoading: false
    };
  },
  [translationTypes.CLEAR_REDUCERS]: (state, action) => INITIAL_STATE
};

export default createReducer(INITIAL_STATE, reducer);
